/** @prettier */

import {
  Select,
  SelectChangeEvent,
  FormControl,
  MenuItem,
  InputLabel,
  Grid,
} from '@mui/material';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

//interface import
import * as apiIF from '../../Type/api';
//Style import
import '../../css/common/common.css';

import {iconBlack} from '../../define';

/**
 * 空調機タイプ設定セレクトボックス
 * @param props props
 * @returns JSX
 */
const SLIFUnitTypeSelectBox = (props: {
  /** 空調機タイプ（set関数） */
  setUnitType: React.Dispatch<
    React.SetStateAction<
      apiIF.reqParameters.postCompositionsSLIFUnit['unit-type']
    >
  >;
  /** 初期値 */
  defaultValue?: apiIF.reqParameters.postCompositionsSLIFUnit['unit-type'];
}) => {
  const trans = useTranslation().t; //翻訳関数

  //prettier-ignore
  const [unitType, setUnitType] = useState(props.defaultValue === undefined ? 'FDT' : props.defaultValue); //空調機のタイプ

  /** セレクトボックス変更時 */
  const handleChange = (event: SelectChangeEvent) => {
    setUnitType(
      event.target
        .value as apiIF.reqParameters.postCompositionsSLIFUnit['unit-type']
    );
    props.setUnitType(
      event.target
        .value as apiIF.reqParameters.postCompositionsSLIFUnit['unit-type']
    );
  };

  return (
    <FormControl variant="standard">
      <InputLabel>{trans('SLIFUnitTypeSelectBox.label')}</InputLabel>
      <Select
        defaultValue={props.defaultValue}
        value={unitType}
        onChange={handleChange}
        className="gwSetting__contents__selectBox--unitTypeSelectBox">
        <MenuItem value="AC">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.AC_ON.src}
                alt={`${trans(
                  `SLIFUnitTypeSelectBox.alternativeText.${iconBlack.AC_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIFUnitTypeSelectBox.value.ac')}
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem value="FDT">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.FDT_ON.src}
                alt={`${trans(
                  `SLIFUnitTypeSelectBox.alternativeText.${iconBlack.FDT_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIFUnitTypeSelectBox.value.fdt')}
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem value="FDTW">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.FDTW_ON.src}
                alt={`${trans(
                  `SLIFUnitTypeSelectBox.alternativeText.${iconBlack.FDTW_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIFUnitTypeSelectBox.value.fdtw')}
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem value="FDTS">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.FDTS_ON.src}
                alt={`${trans(
                  `SLIFUnitTypeSelectBox.alternativeText.${iconBlack.FDTS_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIFUnitTypeSelectBox.value.fdts')}
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem value="FDE">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.FDE_ON.src}
                alt={`${trans(
                  `SLIFUnitTypeSelectBox.alternativeText.${iconBlack.FDE_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIFUnitTypeSelectBox.value.fde')}
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem value="FDF">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.FDF_ON.src}
                alt={`${trans(
                  `SLIFUnitTypeSelectBox.alternativeText.${iconBlack.FDF_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIFUnitTypeSelectBox.value.fdf')}
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem value="FDFW">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.FDFW_ON.src}
                alt={`${trans(
                  `SLIFUnitTypeSelectBox.alternativeText.${iconBlack.FDFW_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIFUnitTypeSelectBox.value.fdfw')}
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem value="FDK">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.FDK_ON.src}
                alt={`${trans(
                  `SLIFUnitTypeSelectBox.alternativeText.${iconBlack.FDK_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIFUnitTypeSelectBox.value.fdk')}
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem value="FDU">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.FDU_ON.src}
                alt={`${trans(
                  `SLIFUnitTypeSelectBox.alternativeText.${iconBlack.FDU_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIFUnitTypeSelectBox.value.fdu')}
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem value="VENT">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.VENTILATOR_UNIT_ON.src}
                alt={`${trans(
                  `SLIFUnitTypeSelectBox.alternativeText.${iconBlack.VENTILATOR_UNIT_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIFUnitTypeSelectBox.value.ventilator')}
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem value="LIGHT">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.LIGHT_UNIT_ON.src}
                alt={`${trans(
                  `SLIFUnitTypeSelectBox.alternativeText.${iconBlack.LIGHT_UNIT_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIFUnitTypeSelectBox.value.light')}
            </Grid>
          </Grid>
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default SLIFUnitTypeSelectBox;
